import React from 'react'
import PropTypes from 'prop-types'

import PrimaryButton from 'components/Shared/Button'
import { SecondaryButton } from 'components/Shared/Button'
import { useTranslation } from 'react-i18next'


const UtilityButton = ({ isActive, canMerge, handleClick, selectAll, isAllSelected = false, setIsSelecting, isSelecting, setHighlightedPackages }) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const btnClassName = `${currentLanguage === 'de' ? 'de-btn' : 'en-btn'}`
  
  return (
    <nav daya-cy="utlity-buttons-component" className="package-builder-page_utility-buttons_wrapper">
      {!isSelecting ? (
        <PrimaryButton
          onClick={() => setIsSelecting(true)}
          className={`package-builder-page_utility-buttons_btn-wrapper ${btnClassName}`}
          text={t('PackageBuilder.select')}
        />
      ) : (
        <PrimaryButton
          onClick={selectAll}
          className={`package-builder-page_utility-buttons_btn-wrapper ${btnClassName}`}
          text={t('PackageBuilder.selectAll')}
          disabled={isAllSelected}
        />
      )} 

      <PrimaryButton
        title={'Merge selected packages'}
        disabled={!isActive && !canMerge}
        onClick={() => handleClick('MERGE')}
        text={t('PackageBuilder.mergePackages')}
      />

      {isSelecting ? (
        <SecondaryButton
          onClick={() => {
            setIsSelecting(false)
            setHighlightedPackages([])
          }}
          color="navy"
          text={t('PackageBuilder.cancel')}
        />
      ) : null}
    </nav>
  )
}

UtilityButton.propTypes = {
  isActive: PropTypes.bool,
  canMerge: PropTypes.bool,
  handleClick: PropTypes.func,
  selectAll: PropTypes.func,
  isAllSelected: PropTypes.bool,
  setIsSelecting: PropTypes.func,
  isSelecting: PropTypes.bool,
  setHighlightedPackages: PropTypes.func,
}

export default UtilityButton
